// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'collab.my',
    path: 'project/:id/partner',
    name: 'ProjectPartnerList',
    component: () => import('./PgProjectPartnerList'),
    meta: {
      title: '合作夥伴列表'
    }
  }
]
